const orange = {
  200: "#FEEED2",
  400: "#FEDDA5",
  900: "#FCAA1D",
  contrastDefaultColor: "#ffffff"
}
export default orange
